<template>
    <div>
        <navbar></navbar>


        <b-row>
            <b-col cols="12" md="4" v-if="role === 'admin'">
                <b-card title="Home">
                    <b-link class="btn btn-primary btn-round" :to="{name:'SettingHome'}">Home Page</b-link>
                </b-card>
            </b-col>
            <b-col cols="12" md="4">
                <b-card title="Text">
                    <b-link class="btn btn-primary btn-round" :to="{name:'SettingText'}">Texts</b-link>
                </b-card>
            </b-col>
            <b-col cols="12" md="4" v-if="role === 'admin'">
                <b-card title="Price">
                    <b-link class="btn btn-primary btn-round" :to="{name:'SettingPrice'}">Price</b-link>
                </b-card>
            </b-col>
            <b-col cols="12" md="4" v-if="role === 'admin'">
                <b-card title="Text">
                    <b-link class="btn btn-primary btn-round" :to="{name:'SettingOrderCancel'}">Bestellungen zurückgeben</b-link>
                </b-card>
            </b-col>
        </b-row>

    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";

    export default {
        name: "Index",
        components: {Navbar},
        data() {
            return {
                role: null
            }
        },
        created() {
            this.role = localStorage.getItem('role');
        }
    }
</script>

<style scoped>

</style>